import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionWrapper } from './SectionWrapper';
import { DownloadIcon, ClockIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
export function Hero() {
  return <SectionWrapper className="pt-32 md:pt-40 pb-16 text-center bg-white" data-id="element-166">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-coral-light text-coral-dark font-sans text-sm font-semibold mb-8" data-id="element-167">
        📖 Para madres y padres de niños de 2 a 7 años
      </div>

      <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-ink mb-6" data-id="element-168">
        Cómo detener un berrinche en{' '}
        <span className="text-coral" data-id="element-169">180 segundos</span> sin gritar, sin
        amenazas y sin perder los nervios
      </h1>

      <p className="font-sans text-xl md:text-2xl text-ink-mid leading-relaxed max-w-3xl mx-auto mb-12 font-medium" data-id="element-170">
        El protocolo táctico para madres y padres que ya están cansados de
        improvisar cada vez que todo explota.
      </p>

      <div className="flex flex-wrap justify-center gap-4 mb-12 max-w-4xl mx-auto" data-id="element-171">
        {[{
        icon: DownloadIcon,
        text: 'Descarga inmediata'
      }, {
        icon: ClockIcon,
        text: 'Léelo en 90 min'
      }, {
        icon: ShieldCheckIcon,
        text: 'Garantía 7 días'
      }, {
        icon: SmartphoneIcon,
        text: 'Funciona en móvil'
      }].map((badge, i) => <div key={i} className="bg-white border border-hairline rounded-xl p-4 flex flex-col items-center gap-2 shadow-sm min-w-[140px] flex-1 md:flex-none" data-id="element-172">
            <badge.icon className="w-6 h-6 text-coral" data-id="element-173" />
            <span className="font-sans text-sm font-semibold text-ink-mid text-center" data-id="element-174">
              {badge.text}
            </span>
          </div>)}
      </div>

      <div className="max-w-2xl mx-auto mb-8" data-id="element-175">
        <CTAButton fullWidth data-id="element-176">
          👉 SÍ QUIERO EL PROTOCOLO AHORA — Acceso inmediato por solo $9.99
        </CTAButton>
      </div>

      <p className="font-sans text-ink-mid font-medium mt-8" data-id="element-177">
        ⭐⭐⭐⭐⭐ Más de 847 familias ya lo están usando
      </p>
    </SectionWrapper>;
}